import React from 'react'

export default function DownloadLicensesCSV() {
    const download = () => {
        document.getElementById("dnload-bible-csv").click()
    }
    return (
    <span onClick={download} style={{cursor: "pointer", marginLeft: "10px"}} title="Export to csv format">
        <i className="fa-solid fa-file-csv"></i>
    </span>
    )
}
